export const config = [{
    twoLinesEditorToolsSpace : {
        maxLength: 2,
        content: [
            [{
                name: "sourceTool", title: "源码", width: 2
            }],
            [{name: "backTool", title: "返回"}, {name: "advanceTool", title: "前进"}]
        ]
    }
},{
    twoLinesEditorToolsSpace : {
        maxLength: 9,
        content: [[{name:"fontFamilyTool", width: 4, title:"字体"},{name:"fontSizeTool",width: 5,title:"字号"}],
            [{name:"boldTool",title:"加粗"},{name:"italicsTool", title: "斜体"},
                {name:"underLineTool", title: "下划线"},{name:"middleLineTool", title: "删除线"},{name:"clearFormatTool", title:"橡皮擦"},
                {name:"formatBrushTool", title: "格式刷"},{name:"textStickTool", title: "纯文本粘贴模式"},{name:"fontColorTool", title: "字体颜色"},
                {name:"fontBgColorTool", title: "字体背景颜色"}]]
    }
},{
    twoLinesEditorToolsSpace : {
        maxLength: 1,
        content: [[{name: 'listBottomTool',title: "无序列表"}],[{name: 'listNumbersTool', title: "有序列表"}]]
    }
},{
    twoLinesEditorToolsSpace : {
        maxLength: 2,
        content: [[{name: 'alignTextLeftTool', title: "左对齐"},{name: 'alignTextCenterTool', title: "居中对齐"}],
            [{name: 'alignTextRightTool', title: "右对齐"},{name: 'alignTextBothTool', title: "两端对齐"}]]
    }
},{
    twoLinesEditorToolsSpace : {
        maxLength: 2,
        content: [[{name: 'rowHeightTool', title: "行间距"},{name: "rowHeightBackTool", title: "段后距"}],
            [{name: 'rowHeightBeforeTool', title: "段前距"},{name: 'rowHeightIndentTool', title: "首行缩进"}]]
    }
},{
    twoLinesEditorToolsSpace : {
        maxLength: 11,
        content: [[
            {name: 'hyperlinkTool', title: "超链接"},{name: 'cuttingLineTool', title: "分割线"},
            {name: 'dateTool', title: "日期"},{name: 'specificSymbolTool', title: "特殊字符"},{name: 'deleteRowsTool', title: "删除行"},
            {name: 'deleteColumnsTool', title: "删除列 "},{name: 'deleteTableTool', title: "删除表格"},{name: 'insertTableTool', title: "插入表格"},
            {name: 'mergeCellsTool', title: "合并多个单元格"},{name: 'subscriptTool', title: "下标 "}, {name: 'superscriptTool', title: "上标"},
            {name: 'floatDefaultTool', title: "默认"},
            {name: 'floatLeftTool', title: "悬浮靠左"},
            {name: 'floatRightTool', title: "悬浮靠右"},
            {name: 'floatCenterTool', title: "悬浮居中"}
            ],

            [{name: 'hyperlinkCancelTool', title: "取消链接"},{name: 'timeTool',title: "时间"},{name: 'tableBeforeInsertRowTool', title: "表格前插入行"},
                {name: 'insertColumnBeforeTool', title: "前插入列"},{name: 'insertRowBeforeTool', title: "前插入行"},{name: 'mergeRightTool', title: "右合并单元格"},
                {name: 'mergeDownTool', title: "向下合并单元格"},{name: 'splitCellsTool', title: "完全拆分单元格"},{name: 'splitRowsTool', title: "拆分成行"},{name:'splitColumnTool', title:"拆分成列"}]]
    }
},

    {
    oneLineToolSpace: ["pictureTool","videoTool",
        // "audioTool",
        "resourceSystemTool","uploadPDFTool"]
},


];